if ($(".id--17").length) {
  $('label[for="billCountryId"]').closest(".form-group").addClass("haveCountyDelivery");

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $(".co-contact-information").prepend(`
            <div class="customLogin">
                    <p>Máte u nás účet? Přihlaste se, údaje se vyplní automaticky. 
                <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);

    $("html").on("click", ".customLoginPopup", function () {
      $("body").addClass("user-action-visible login-window-visible");
    });
  }
}

if ($(".id--9").length) {
  $(document).ready(function () {
    loadFooter(emptyCart);
  });
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    loadFooter(emptyCart);
  });
  function emptyCart() {
    if ($(".cart-empty").length) {
      $("body").addClass("cartEmpty");
      $("h1.cart-heading").after($("#footer .emptyCartText").clone());
      $('<div class="text-center"><a href="/" class="btn btn-conversion">Vybrat z našich produktů</a></div>').appendTo(".cart-empty");

      if (!$(".categories").length) {
        if (sessionStorage.emptyCartCategories && sessionStorage.emptyCartCategories !== "undefined") {
          $(".cart-empty").append('<div class="categories">' + sessionStorage.emptyCartCategories + "</div>");
          if (sessionStorage.emptyCartReviews && sessionStorage.emptyCartReviews !== "undefined") {
            $(".cart-empty").append('<div class="reviewsWrap">' + sessionStorage.emptyCartReviews + "</div>");
            if (typeof loadStoreRating === "function") loadStoreRating();
          }
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 10000,
            cache: true,
            url: "/",
            success: function (e) {
              var doc = shoptet.common.createDocumentFromString(e);

              // Kategorie
              var categoriesHtml = $(doc).find(".categories").html();
              if (categoriesHtml) {
                $(".cart-empty").append('<div class="categories">' + categoriesHtml + "</div>");
                sessionStorage.emptyCartCategories = categoriesHtml;
              }

              // reviewsWrap
              var reviewsWrapHtml = $(doc).find(".reviewsWrap").html();
              if (reviewsWrapHtml) {
                $(".cart-empty").append('<div class="reviewsWrap">' + reviewsWrapHtml + "</div>");
                sessionStorage.emptyCartReviews = reviewsWrapHtml;
                if (typeof loadStoreRating === "function") loadStoreRating();
              }
            },
          });
        }
      }
    }
  }

  dataHandle();
  function dataHandle() {
    let maxDeliveryDate = null;
    //console.log("test");
    $("tr.removeable").each(function () {
      $(this)
        .find(".availability-amount")
        .each(function () {
          const $amount = $(this);
          $amount.attr("style", $(this).prev(".availability-label").attr("style"));
          // console.log($amount);
          const availabilityCartText = $(this).prev(".availability-label").text().trim().toLowerCase();
          const deliveryCartDate = getDeliveryDateByAvailability(availabilityCartText);

          if (!deliveryCartDate) return;

          // 👉 uložíme nejvyšší datum
          if (!maxDeliveryDate || deliveryCartDate > maxDeliveryDate) {
            maxDeliveryDate = deliveryCartDate;
          }
          const formattedCartDate = formatDeliveryDate(deliveryCartDate);
        });
    });
    if (maxDeliveryDate) {
      const formattedMaxDate = maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";
      localStorage.setItem("maxDeliveryDate", formattedMaxDate);
    }
  }
}

if ($(".id--9").length) {
  // blok "doprava zdarma" (shopcode) – události: ShopcodeDopravaZdarmaVlozeny / ShopcodeDopravaZdarmaOdebrani
  const initDopravaZdarmaSlider = ($karty) => {
    if (!$karty.length || $karty.hasClass("slick-initialized")) return;
    $karty.find(".shopcode-doprava-zdarma__pridat").addClass("btn btn-cart add-to-cart-button").html("<span>Do košíku</span>");
    // slick slide = wrapper, aby šla mezi kartami udělat mezera (padding slidu + záporný margin listu)
    $karty.children(".shopcode-doprava-zdarma__karta").wrap("<div></div>");
    $karty.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 2 } },
        { breakpoint: 991, settings: { slidesToShow: 2 } },
        { breakpoint: 550, settings: { slidesToShow: 1.2 } },
      ],
    });
  };

  // "219 Kč / 1 299 Kč" nad (telefon) / vpravo (od 768px) v textu bloku; limit se dopočítá z chybějící částky a šířky ukazatele
  const setSoucetDopravaZdarma = ($blok, $source) => {
    const $text = $blok.children(".shopcode-doprava-zdarma__text");
    const zbyva = parseFloat($source.closest(".delivery").find("strong").first().text().replace(/[^\d,]/g, "").replace(",", "."));
    const pct = parseFloat($source.children("div")[0]?.style.width);
    if (!$text.length || !zbyva || isNaN(pct) || pct >= 100) return;
    const limit = Math.round(zbyva / (1 - pct / 100));
    const fmt = (n) => n.toLocaleString("cs-CZ").replace(/\s/g, " ") + " Kč";
    let $soucet = $text.children(".shopcode-doprava-zdarma__soucet");
    if (!$soucet.length) $soucet = $('<span class="shopcode-doprava-zdarma__soucet"></span>').prependTo($text);
    $soucet.text(fmt(limit - Math.round(zbyva)) + " / " + fmt(limit));
  };

  // kopie ukazatele "doprava zdarma" (.price-range) pod nadpis bloku
  const copyPriceRange = ($blok) => {
    const $source = $(".cart-content .price-range").not($blok.find(".price-range")).first();
    if (!$source.length) return;
    setSoucetDopravaZdarma($blok, $source);
    const $copy = $blok.children(".price-range");
    if ($copy.length) {
      $copy.html($source.html());
    } else {
      $blok.children(".shopcode-doprava-zdarma__nadpis").after($source.clone());
    }
  };

  document.addEventListener("ShopcodeDopravaZdarmaVlozeny", function (e) {
    const $blok = $(e.detail.prvek);
    initDopravaZdarmaSlider($(e.detail.karty));
    copyPriceRange($blok);
  });

  document.addEventListener("ShopcodeDopravaZdarmaOdebrani", function (e) {
    const $karty = $(e.detail.karty);
    if ($karty.hasClass("slick-initialized")) $karty.slick("unslick");
  });

  // po chybě při změně počtu (např. omezený počet kusů) Shoptet překreslí košík bez ShoptetCartUpdated,
  // moduly shopcode (nabídky, doprava zdarma) se pak nevykreslí znovu – dorovnáme to sami
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    setTimeout(function () {
      if (!$(".cart-content").length || $(".cart-content .shopcode-doprava-zdarma-misto").length) return;
      document.dispatchEvent(new CustomEvent("ShoptetCartUpdated"));
    }, 600);
  });

  // blok mohl být vložen dřív, než se načetl tento skript
  $(".shopcode-doprava-zdarma").each(function () {
    initDopravaZdarmaSlider($(this).find(".shopcode-doprava-zdarma__karty"));
    copyPriceRange($(this));
  });
}

$("html").on("click", ".remove-item", function (e) {
  const $removeButton = $(this);
  const $form = $removeButton.closest("form");
  const itemId = $form.find('input[name="itemId"]').val();

  if (!itemId) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  openRemoveConfirm(itemId);
});

$("html").on("click", ".cart-table .quantity .decrease, .cart-widget-product .quantity .decrease", function (e) {
  const $button = $(this);
  const $form = $button.closest("form");
  const amount = parseInt($form.find('input[name="amount"]').val(), 10) || 0;

  if (amount > 1) return;

  const itemId = $form.find('input[name="itemId"]').val();
  if (!itemId) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  openRemoveConfirm(itemId);
});

function openRemoveConfirm(itemId) {
  $.colorbox({
    html: `
      <div class="cartRemoveConfirm">
        <p>Opravdu chcete tento produkt odstranit z košíku?</p>
        <div class="buttons">
          <button class="btn btn-alert confirmRemove" type="button" data-id="${itemId}">Odstranit</button>
          <button class="btn btn-conversion cancelRemove" type="button">Ponechat</button>
        </div>
      </div>
    `,
    width: 310,
    maxWidth: "90%",
    className: "customRemoveCart",
    transition: "none",
    speed: 0,
    fixed: true,
    onComplete: function () {
      $.colorbox.resize({ width: 310, height: "auto" });
    },
    onClosed: function () {
      $("#colorbox").removeClass("customRemoveCart");
    },
  });
}

$(document).on("click", ".confirmRemove", function () {
  const itemId = $(this).attr("data-id");
  if (itemId && typeof shoptet !== "undefined" && shoptet.cartShared) {
    shoptet.cartShared.removeFromCart({ itemId: itemId });
  }
  $.colorbox.close();
});

$(document).on("click", ".cancelRemove", function () {
  $.colorbox.close();
});

if ($("body.ordering-process").length) {
  loadFooter(() => {});
}

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));
  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());

  $.get("/action/Cart/GetCartContent/?orderingProcessActive=1", function (data) {
    $('.cart-item[data-micro="cartItem"]').each(function () {
      get_id = $(this).attr("data-micro-sku");
      var $row = $(this);
      link = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image a')
        .attr("href");
      image = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image img')
        .attr("data-src")
        .split("?")[0]
        .replace("/related/", "/orig/");
      if (!$(this).find(".right").length) {
        $(this).wrapInner('<div class="right"></div>');
        $(this).prepend('<div class="image"><a href="' + link + '"><img src="' + image + '" alt="' + $(this).find('a[data-testid="recapItemName"]').text() + '"></a></div>');
      }
    });
  });
}
if ($(".id--16").length) {
  const maxDate = localStorage.getItem("maxDeliveryDate");
  if (maxDate) {
    $(".order-delivery-payment-form #order-shipping-methods .payment-shipping-price").each(function () {
      const $price = $(this);
      // prevence duplicity
      $price.find(".customDateDelivery").remove();
      $price.append(`
            <span class="customDateDelivery">
           Můžete mít již ${maxDate}
            </span>
        `);
      $price.closest("label").find(".payment-info").append(`
            <span class="customDateDelivery">
        Můžete mít již ${maxDate}
            </span>
        `);
    });
  }
}
function mhProductInfoMove() {
  if ($(".id--9").length) {
    $("tr.removeable").each(function () {
      $(this).find(".p-name").append($(this).find(".p-availability").clone());
      $(this).find(".p-total").append($(this).find(".p-price").clone());

      if ($(this).find(".p-name a.show-related").length) {
        $(this).find(".p-name .show-related").text("Nepotřebujete něco?");
      }
    });

    $(".summary-wrapper").after($(".next-step-back"));

    $(".summary-wrapper").prepend('<div class="customBox"></div>');

    $(".customBox").append(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                Mám slevový kód
            </label>
        `);
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="sale">Sleva</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $("tr.removeable").each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find(".p-price .show-tooltip").attr("title") || $row.find(".p-price .show-tooltip").attr("data-original-title");
          console.log();
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(",", "."))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, "")) : 0;
          const finalPrice = parseInt($row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, ""));
          const quantity = parseInt($row.find("input.amount").val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find(".p-price").append(`
                    <span class="sale-percent">${percent}%</span>
                `);
          $row.find(".p-total").before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      } else {
        $row.find(".p-total").before('<td class="p-sale"></td>');
      }
    });
    if (totalSaved > 0) {
      $(".price-wrapper").append(`
            <span class="price-label price-secondary" style="color:#118819;">
            Ušetřili jste:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }
  } else {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
  }

  $(".summary-wrapper .customBox").append($(".cart-summary .discount-coupon").clone());

  $("#discount-checkbox").on("change", function () {
    $(".discount-coupon").toggleClass("active", this.checked);
  });

  // slevový kód je po načtení stránky rozbalený
  $("#discount-checkbox").prop("checked", true);
  $(".discount-coupon").addClass("active");

  if ($(".delivery-time").length) {
    $(".customBox").append($(".delivery-time"));
  }

  if ($(".discount-coupon .applied-coupon").length) {
    $(".discount-coupon").addClass("active");
    $("#discount-checkbox").prop("checked", true);
    $('input[data-testid="buttonRemoveDiscountCoupon"]').attr("value", "Odebrat kupon");
  }
}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  mhProductInfoMove();
});

if ($(".id--15").length) {
  $("h1.order-summary-heading").text("Objednávka přijata");
  $("h1.order-summary-heading").after("<p>Děkujeme za Vaši objednávku</p>");
  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith("Její číslo: ");

  $('.recapitulation-wrapper[data-testid="recapTable"]').append('<div class="co-box co-extra"></div>');
  $(".co-box.co-extra").append($('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])'));
  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);
    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");
      $row.append('<td class="zdarma"><span>Zdarma</span></td>');
      $row.find("strong.for-free").text("Dárek k objednávce");
    }
    const $cell = $row.find("td.p-quantity");
    if (!$cell.length) return;

    const total = parseFloat($cell.find("strong").text().replace(/\s/g, "").replace("Kč", "").replace(",", "."));
    $row.append(`<td class="pricePerSingle"><span>${total} / ks</span></td>`);
  });
  $(".recapitulation-wrapper:first").append('<a href="/">Zpět do obchodu</a>');
}

$("html").on("click", ".id--17 .customLoginPopup", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  $("body").addClass("user-action-visible login-window-visible");
});
